module.exports = __webpack_public_path__ + "assets/img/en-99397348.png";